var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"phone-button"},[_c('a',{staticClass:"phone-button__link",attrs:{"href":`tel:${_vm.phone}`,"target":"_blank"}},[_c('IconComponent',{attrs:{"category":"vuesax-bold","name":"call"}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }